import React from 'react';
import { eachDayOfInterval, endOfMonth, endOfWeek, format, isSameMonth, isWeekend, startOfMonth, startOfWeek } from 'date-fns';
import type { Holiday } from '../../types/selfService';
import { TODAY } from '../../utils/format';
import { holidayMap } from '../../utils/holidays';
interface YearCalendarProps {
  year: number;
  holidays: Holiday[];
  onSelect?: (holiday: Holiday) => void;
}
const WEEKDAYS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
const TODAY_ISO = format(TODAY, 'yyyy-MM-dd');
export function YearCalendar({
  year,
  holidays,
  onSelect
}: YearCalendarProps) {
  const map = holidayMap(holidays);
  return <div data-id="element-146" data-mp="5kzjmzb85t4b">
      <div className="grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4" data-id="element-147" data-mp="5k7nnndpttdi">
        {Array.from({
        length: 12
      }, (_, m) => {
        const month = new Date(year, m, 1);
        const days = eachDayOfInterval({
          start: startOfWeek(startOfMonth(month)),
          end: endOfWeek(endOfMonth(month))
        });
        return <div key={m} data-id="element-148" data-mp="3r558ujp5qp4g">
              <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-navy" data-id="element-149" data-mp="3r5ov2clubzoa">{format(month, 'MMMM')}</p>
              <div className="grid grid-cols-7 gap-0.5 text-center" data-id="element-150" data-mp="3mdx0zs3h7bte">
                {WEEKDAYS.map((d, i) => <span key={i} className="text-[10px] font-medium text-muted" data-id="element-151" data-mp="3hfvhj6251ahe" data-mpi={i}>
                    {d}
                  </span>)}
                {days.map(d => {
              const iso = format(d, 'yyyy-MM-dd');
              if (!isSameMonth(d, month)) return <span key={iso} aria-hidden="true" data-id="element-152" data-mp="90txs5d542s7" />;
              const h = map.get(iso);
              const isToday = iso === TODAY_ISO;
              let cls = isWeekend(d) ? 'text-slate-300' : 'text-slate-600';
              if (h) {
                const base = h.kind === 'Company' ? 'bg-flame text-white' : 'bg-navy text-white';
                const half = h.kind === 'Company' ? 'bg-flame/20 text-[#c25a00] ring-1 ring-inset ring-flame/50' : 'bg-navy/15 text-navy ring-1 ring-inset ring-navy/40';
                cls = `${h.halfDay ? half : base} font-semibold`;
              }
              if (isToday && !h) cls = 'font-semibold text-azure ring-1 ring-inset ring-azure';
              return h ? <button key={iso} type="button" onClick={() => onSelect?.(h)} title={`${h.name}${h.halfDay ? ' · half day' : ''} · ${h.kind}`} aria-label={`${format(d, 'MMMM d')}: ${h.name}`} className={`flex h-7 items-center justify-center rounded-lg text-[11px] transition hover:opacity-80 ${cls}`} data-id="element-153" data-mp="2h7f7o8amac4g">
                      {format(d, 'd')}
                    </button> : <span key={iso} className={`flex h-7 items-center justify-center rounded-lg text-[11px] ${cls}`} data-id="element-154" data-mp="1kifz0s64f8bq">
                      {format(d, 'd')}
                    </span>;
            })}
              </div>
            </div>;
      })}
      </div>
      <ul className="mt-6 flex flex-wrap gap-x-5 gap-y-2 border-t border-slate-100 pt-4 text-xs text-muted" data-id="element-155" data-mp="10wegkgo4c881">
        <li className="flex items-center gap-1.5" data-id="element-156" data-mp="1evxfciv1i77o">
          <span className="h-3 w-3 rounded bg-navy" aria-hidden="true" data-id="element-157" data-mp="19waylzg068u4" /> Federal holiday
        </li>
        <li className="flex items-center gap-1.5" data-id="element-158" data-mp="1ot20qgh29ynf">
          <span className="h-3 w-3 rounded bg-flame" aria-hidden="true" data-id="element-159" data-mp="1orqyil39kyyf" /> Company day
        </li>
        <li className="flex items-center gap-1.5" data-id="element-160" data-mp="1jtpe9wu3qtld">
          <span className="h-3 w-3 rounded bg-flame/20 ring-1 ring-inset ring-flame/50" aria-hidden="true" data-id="element-161" data-mp="1xldn9r9211y4" /> Half day
        </li>
        <li className="flex items-center gap-1.5" data-id="element-162" data-mp="1tl3cm1abhncx">
          <span className="h-3 w-3 rounded ring-1 ring-inset ring-azure" aria-hidden="true" data-id="element-163" data-mp="27jt6z95r58xl" /> Today
        </li>
      </ul>
    </div>;
}